import API_URL from "@/constant/api.config";
import axios from "axios";
import { btoa } from "js-base64";
import { isEmpty, trim } from "lodash";

export const getGalleryImages = async () => {
    const response = await axios.get(API_URL + "/image-gallery");
    return response.data ? response.data.data : [];
}

export const getBlogPosts = async (filterObj) => {
    let fObj = filterObj;
    let serach_term = fObj.search_term;
    serach_term = trim(serach_term);
    serach_term = btoa(serach_term);
    const searchQueryString = isEmpty(serach_term) ? '' : ('/' + serach_term);

    const response = await axios.get(API_URL + "/blog-list/" + fObj.offset + "/" + fObj.limit + "/" + fObj.column_name + "/" + fObj.sort_dir + searchQueryString);
    return response.data ? response.data : [];
}

export const getBlogDetail = async (blog_slug) => {
    const response = await axios.get(API_URL + "/blog-detail/" + blog_slug);
    return response.data ? response.data.data : null;
}

export const recentBlogPosts = async (blog_id) => {
    const response = await axios.get(API_URL + "/recent-blogs/" + blog_id);
    return response.data ? response.data.data : null;
}